// extracted by mini-css-extract-plugin
export var buttonContainer = "_a3-1";
export var fontSizeSelect = "_a3-3";
export var formatSelect = "_a3-2";
export var formats = "_a3-4";
export var hidden = "_a3-5";
export var icon = "_a3-6";
export var select = "_a3-0";